import { memo } from 'react';

import DocsIconSVG from '@/assets/docs-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDocsIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={DocsIconSVG} {...props} />;

export const DocsIcon = memo(IDocsIcon) as typeof IDocsIcon;
